import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { editRole, roleDetails } from "../action/role";
import { toast } from "react-toastify";
import validator from "validator";

const EditRoleDetailsModal = ({ show, onClose, roleId, onSuccess }) => {
  const [roleName, setRoleName] = useState("");
  const [desc, setDesc] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (show && roleId) {
      fetchRoleDetail();
    }
  }, [show, roleId]);

  const fetchRoleDetail = async () => {
    try {
      const res = await roleDetails(roleId);
      if (res?.status) {
        const role = res.data;
        setDetails(role);
        setRoleName(role.name);
        setDesc(role.description || "");
        setErrors({});
      }
    } catch (error) {
      console.log("Role Detail Error");
      toast.error("Failed to fetch role details");
    }
  };

  const validateForm = () => {
    let newErrors = {};

    if (!validator.trim(roleName || "")) {
      newErrors.roleName = "Role name is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    try {
      if (!validateForm()) return;

      setLoading(true);

      // Keep existing access levels
      const user_access_levels = details?.user_access_levels || [];

      const payload = {
        name: roleName,
        description: desc,
        user_access_levels,
      };

      const res = await editRole(roleId, payload);
      if (res.status) {
        toast.success("Role updated successfully");
        setRoleName("");
        setDesc("");
        setDetails(null);
        onClose();
        if (onSuccess) onSuccess();
      } else {
        toast.error(res.message || "Failed to update role");
      }
    } catch (error) {
      console.log("Error updating role", error);
      toast.error("Failed to update role");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Role Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="frm-group">
          <label className="frm-label">Role Name</label>
          <input
            type="text"
            className="frm-input"
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
            placeholder="Enter role name"
          />
          {errors.roleName && (
            <div className="text-danger mt-1">{errors.roleName}</div>
          )}
        </div>

        <div className="frm-group">
          <label className="frm-label">Description</label>
          <textarea
            rows={3}
            className="frm-input"
            value={desc}
            onChange={(e) => setDesc(e.target.value)}
            placeholder="Enter role description"
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn-white"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </button>
        <button
          className="btn-black"
          onClick={handleUpdate}
          disabled={loading}
        >
          {loading ? "Updating..." : "Update"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditRoleDetailsModal;
